import { fetchWithCsrf } from 'js/utils/fetch_with_csrf';
import routes from 'js/core_pre_webpack/routes';
import { updateButtons } from 'js/profiles/setUpLeftSidebarButtons';
import { currentUser } from 'js/utils/user';
import {
  addInterest,
  hasInterest,
  removeInterest,
} from 'js/utils/user_research_interests';

function updateAllResearchInterestButtonStates() {
  if (!currentUser) {
    return;
  }

  const riIds = new Set<string>();
  document.querySelectorAll('[data-follow-ri-id]').forEach((el) => {
    const riId = el.getAttribute('data-follow-ri-id');
    if (riId) {
      riIds.add(riId);
    }
  });
  document.querySelectorAll('[data-unfollow-ri-id]').forEach((el) => {
    const riId = el.getAttribute('data-unfollow-ri-id');
    if (riId) {
      riIds.add(riId);
    }
  });

  riIds.forEach((riId) => {
    if (hasInterest(parseInt(riId))) {
      document
        .querySelector(`[data-follow-ri-id="${riId}"]`)
        ?.classList.add('hidden');
      document
        .querySelector(`[data-unfollow-ri-id="${riId}"]`)
        ?.classList.remove('hidden');
    } else {
      document
        .querySelector(`[data-follow-ri-id="${riId}"]`)
        ?.classList.remove('hidden');
      document
        .querySelector(`[data-unfollow-ri-id="${riId}"]`)
        ?.classList.add('hidden');
    }
  });
}

const followRI = async (researchInterestId: string) => {
  if (!currentUser) {
    throw new Error('User not logged in');
  }
  const res = await postRIFollowChange(
    researchInterestId,
    routes.add_api_v0_taggings_path({
      subdomain_param: 'api',
      tag_type: 'ResearchInterest',
      target_type: 'User',
      target_id: currentUser.id,
    }),
  );
  const data = await res.json();
  addInterest(data.research_interest.id);
  return res;
};

const unfollowRI = async (researchInterestId: string) => {
  if (!currentUser) {
    throw new Error('User not logged in');
  }
  const res = await postRIFollowChange(
    researchInterestId,
    routes.remove_api_v0_taggings_path({
      subdomain_param: 'api',
      tag_type: 'ResearchInterest',
      target_type: 'User',
      target_id: currentUser.id,
    }),
  );
  removeInterest(parseInt(researchInterestId));
  return res;
};

const postRIFollowChange = async (researchInterestId: string, url: string) => {
  const response = await fetchWithCsrf(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      tag: {
        id: researchInterestId,
      },
    }),
  });

  return response;
};

export function initializeResearchInterestFollowButtons() {
  if (!currentUser) {
    return;
  }

  document.querySelectorAll('[data-follow-ri-id]').forEach((element) => {
    element.addEventListener('click', async (e) => {
      e.preventDefault();

      const el = e.currentTarget;

      if (!(el instanceof HTMLElement)) {
        throw new Error('data-follow-ri-id target is not an HTMLElement');
      }

      const researchInterestId = el.getAttribute('data-follow-ri-id');

      if (!researchInterestId) {
        throw new Error('data-follow-ri-id is not set');
      }

      const res = await followRI(researchInterestId);
      updateButtons(
        el,
        `[data-unfollow-ri-id="${researchInterestId}"]`,
        res.ok,
      );
    });
  });

  document.querySelectorAll('[data-unfollow-ri-id]').forEach((element) => {
    element.addEventListener('click', async (e) => {
      e.preventDefault();

      const el = e.currentTarget;

      if (!(el instanceof HTMLElement)) {
        throw new Error('data-unfollow-ri-id target is not an HTMLElement');
      }

      const researchInterestId = el.getAttribute('data-unfollow-ri-id');

      if (!researchInterestId) {
        throw new Error('data-unfollow-ri-id is not set');
      }

      const res = await unfollowRI(researchInterestId);
      updateButtons(el, `[data-follow-ri-id="${researchInterestId}"]`, res.ok);
    });
  });

  updateAllResearchInterestButtonStates();
}
